import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { OrderStatus } from '@models/order/orderLog';
import { OrderStep } from '@models/order/orderLog/extension';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import Dot from './Dot';
import styles from './styles.module.scss';

interface Props {
    orderStatus: OrderStatus
}

function OrderProgress({ orderStatus }:Props) {
    const { t } = useTranslation('orderLog');
    const step = OrderStep[orderStatus];
    const progressWidth = (step / 3) * 100;
    if (orderStatus === 'CANCELLED') {
        return (<Fragment/>);
    }
    return (
        <Container fullWidth>
            <ProgressWrapper>
                <div className={styles.progress}>
                    <div className={styles.progressBar} style={{ width: `calc(${progressWidth}% + 40px)` }}/>
                    <Dot isActive={step === 0}/>
                    <Dot isActive={step === 1}/>
                    <Dot isActive={step === 2}/>
                    <Dot isActive={step === 3}/>
                </div>
            </ProgressWrapper>
            <Texts>
                <Text fontWeight='bold'
                    align='center'
                    color={orderStatus === 'NEW' ? colors.red : colors.gray6}>
                    {t('progress.paymentCompleted')}
                </Text>
                <Text fontWeight='bold'
                    align='center'
                    color={orderStatus === 'PREPARING' ? colors.red : colors.gray6}>
                    {t('progress.orderConfirmed')}
                </Text>
                <Text fontWeight='bold'
                    align='center'
                    color={orderStatus === 'READY' ? colors.red : colors.gray6}>
                    {t('progress.preparationCompleted')}
                </Text>
                <Text fontWeight='bold'
                    align='center'
                    color={orderStatus === 'DONE' ? colors.red : colors.gray6}>
                    {t('progress.pickupCompleted')}
                </Text>
            </Texts>
        </Container>
    );
}

const Texts = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    width: 100%;
`;

const Container = styled(Column)`
    padding: 4px 0 0;
`;

const ProgressWrapper = styled.div`
    width: 100%;
    padding: 0 20px;
`;

export default OrderProgress;
